<section class="privacy">
  <div class="privacy__container">

    <!-- Header -->
    <div class="privacy__header">
      <p class="privacy__meta">{{ 'privacy_policy.meta' | translate }}</p>
      <h1 class="privacy__title">
        {{ 'privacy_policy.title_1' | translate }}
        <span class="privacy__title-accent">{{ 'privacy_policy.title_2' | translate }}</span>
      </h1>
      <p class="privacy__updated">{{ 'privacy_policy.updated' | translate }}</p>
    </div>

    <!-- Sections -->
    <div class="privacy__content">

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">01</span> {{ 'privacy_policy.s1_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s1_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">02</span> {{ 'privacy_policy.s2_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s2_body_1' | translate }}</p>
        <p class="privacy__section-body">{{ 'privacy_policy.s2_body_2' | translate }}</p>
        <p class="privacy__section-body">{{ 'privacy_policy.s2_body_3' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">03</span> {{ 'privacy_policy.s3_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s3_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">04</span> {{ 'privacy_policy.s4_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s4_body_1' | translate }}</p>
        <p class="privacy__section-body">{{ 'privacy_policy.s4_body_2' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">05</span> {{ 'privacy_policy.s5_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s5_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">06</span> {{ 'privacy_policy.s6_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s6_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">07</span> {{ 'privacy_policy.s7_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s7_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">08</span> {{ 'privacy_policy.s8_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s8_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">09</span> {{ 'privacy_policy.s9_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s9_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">10</span> {{ 'privacy_policy.s10_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s10_body' | translate }}</p>
      </div>

      <div class="privacy__section">
        <h2 class="privacy__section-title"><span class="privacy__section-num">11</span> {{ 'privacy_policy.s11_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s11_body' | translate }}</p>
      </div>

      <!-- Contact -->
      <div class="privacy__contact">
        <h2 class="privacy__contact-title"><span class="privacy__section-num">12</span> {{ 'privacy_policy.s12_title' | translate }}</h2>
        <p class="privacy__section-body">{{ 'privacy_policy.s12_body' | translate }}</p>
        <p [innerHTML]="'privacy_policy.s12_email' | translate"></p>
        <!-- <a class="privacy__contact-email" href="mailto:{{ 'privacy_policy.s12_email' | translate }}">{{ 'privacy_policy.s12_email' | translate }}</a> -->
      </div>

    </div>
  </div>
</section>
